import axios from 'axios'
import type { AxiosInstance, AxiosRequestConfig, AxiosResponse, AxiosError } from 'axios'
import { message as Message } from 'ant-design-vue'
import { useI18n } from 'vue-i18n'

const request: AxiosInstance = axios.create({
  baseURL: '',
  timeout: 60000,
  headers: {
    'Authorization': 'Basic U1lTVEVNOlNZU1RFTQ==',
  }
})

/* 请求拦截器 */
request.interceptors.request.use((config) => {
  //  伪代码
  // if (localStorage.getItem('lang')) {
    config.headers['Accept-Language'] = localStorage.getItem('lang') || 'zh-CN'
  // }
  return config
}, (error: AxiosError) => {
  Message.error(error.message);
  return Promise.reject(error)
})
/* 响应拦截器 */
request.interceptors.response.use((response: AxiosResponse) => {
  const { status, message, data } = response.data
  // 根据自定义错误码判断请求是否成功
  if (status === 1) {
    // 将组件用的数据返回
    return data
  } else {
    // 处理业务错误。
    if (localStorage.getItem('lang') && localStorage.getItem('lang') === 'en-US') {
      if (message === '用户名或者密码错误') {
        Message.error('Invalid username or password.')
      } else if (message === '密码错误') {
        Message.error('Incorrect password.')
      } else if (message === '验证码错误') {
        Message.error('Incorrect verification code')
      } else if (message === '用户尚未加入,请通过激活链接设置密码') {
        Message.error('The user has not joined yet. Please set a password through the activation link')
      } else if (message === '密码尝试次数过多，您还有3次机会') {
        Message.error('Too many password attempts. You have 3 remaining attempts.')
      } else if (message === '密码尝试次数过多，您还有2次机会') {
        Message.error('Too many password attempts. You have 2 remaining attempts.')
      } else if (message === '密码尝试次数过多，您还有1次机会') {
        Message.error('Too many password attempts. You have 1 remaining attempts.')
      } else if (message === '密码尝试次数过多，请10分钟后重新登录') {
        Message.error('Too many failed attempts. Please try again in 10 minutes.')
      }
      else {
        Message.error(message)
      }

    } else {
      Message.error(message)
    }
    return Promise.reject(new Error(message))
  }
}, (error: AxiosError) => {
  // 处理 HTTP 网络错误
  let message = ''
  // HTTP 状态码
  const status = error.response?.status
  switch (status) {
    case 401:
      message = 'token 失效，请重新登录'
      // 这里可以触发退出的 action
      break;
    case 403:
      message = '拒绝访问'
      break;
    case 404:
      message = '请求地址错误'
      break;
    case 500:
      message = '服务器故障'
      break;
    default:
      message = '网络连接故障'
  }
  Message.error(message)
  return Promise.reject(error)
})
export default request